import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { LinkIcon } from "@heroicons/react/24/outline";
import { useRichTextEditorContext } from "@mantine/tiptap";
import { useState } from "react";

export const LinkButton: React.FC = () => {
    const { editor } = useRichTextEditorContext();
    const [url, setUrl] = useState("");

    if (!editor) {
        return null;
    }

    const isTextSelected = editor.state.selection.content().size > 0;

    const handleConfirm = () => {
        const isTextSelected = editor.state.selection.content().size > 0;
        if (url && isTextSelected) {
            const fullUrl =
                url.startsWith("http://") || url.startsWith("https://")
                    ? url
                    : `https://${url}`;

            editor
                .chain()
                .focus()
                .setLink({ href: fullUrl, target: "_blank" })
                .run();

            setUrl("");
        }
    };

    return (
        <Popover>
            <PopoverButton
                className="flex items-center gap-2 disabled:opacity-50 size-6 justify-center"
                disabled={!isTextSelected}
                title="Add link"
            >
                <LinkIcon className="size-4" />
            </PopoverButton>
            <PopoverPanel
                anchor="bottom end"
                transition
                className="w-52 origin-top-right rounded-lg border border-gray-200 bg-white p-1 text-sm/6 transition duration-100 ease-out [--anchor-gap:var(--spacing-1)] p-3"
            >
                {({ close }) => (
                    <div className="flex flex-col gap-2">
                        <input
                            type="url"
                            value={url}
                            onChange={(e) => setUrl(e.target.value)}
                            placeholder="Enter URL..."
                            className="w-full rounded border border-gray-200 px-2 py-1 text-sm"
                        />
                        <button
                            onClick={() => {
                                handleConfirm();
                                close();
                            }}
                            className="rounded bg-blue-500 px-3 py-1 text-white hover:bg-blue-600"
                        >
                            Add Link
                        </button>
                    </div>
                )}
            </PopoverPanel>
        </Popover>
    );
};
